import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=d9cf354c"
import script from "../../controllers/admin/admin-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/admin/admin-edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports